










































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon, IconConfig } from '../sw-icon';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-count-block';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwCountBlock extends SwExtendedVue {
  @Prop({ type: String, required: true })
  label: string;

  @Prop({ type: [Number, Array], required: true })
  count: number | number[];

  @Prop({ type: [String, Array], default: undefined })
  unit: string | string[];

  @Prop({ type: String, default: undefined })
  color: string;

  @Prop({ type: String, default: undefined })
  iconColor: string;

  @Prop({ type: Object, default: null })
  icon: IconConfig | void;

  @Prop({ type: String, default: 'left' })
  orientation: 'left' | 'right';

  @Prop({ type: String, default: 'dark' })
  theme: 'light' | 'dark';

  @Prop({ type: Boolean, default: false })
  clickable: boolean;

  cssPrefix = cssPrefix;

  /** we will be using divider if the block is transparent and only icon is shown */
  get useDivider() {
    return !this.color && !!this.icon;
  }

  get blockStyle(): CSSStyleOptions {
    return {
      backgroundColor: this.color,
      color: this.iconColor || 'white',
    };
  }

  get lineStyle(): CSSStyleOptions | null {
    if (!this.useDivider) { return null; }
    return {
      background: `linear-gradient(transparent, ${this.iconColor}, transparent)`,
    };
  }

  get effectiveIcon(): IconConfig | null {
    if (!this.icon) { return null; }
    return Object.assign(
      {} as IconConfig,
      { size: 28 } as IconConfig,
      this.icon,
    );
  }

  get displayUnit(): string {
    if (Array.isArray(this.count)) {
      return this.count.map<string>((c, index) => {
        const commasCount = utilService.numberWithCommas(c);
        if (Array.isArray(this.unit) && this.unit[index]) {
          return `${commasCount} ${this.unit[index]}`;
        }
        if (this.unit) {
          return `${commasCount} ${this.unit}`;
        }
        return String(commasCount);
      })
        .join(' / ');
    }
    return utilService.numberWithCommas(this.count);
  }
}
